<template>
  <el-button
    :disabled="disabled"
    type="warning"
    icon="el-icon-edit"
    circle
    @click="$emit('click')"
  />
</template>

<script>
import { createComponent } from '@vue/composition-api'

const EditButton = createComponent({
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {

    }
  },
})

export default EditButton
</script>
